/*
 * EditTeacher Messages
 *
 * This contains all the text for the EditTeacher component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    header: {
        id: 'app.containers.EditTeacher.header',
        defaultMessage: 'This is EditTeacher container !'
    },
    emailSent: {
        id: 'app.containers.EditTeacher.emailSent',
        defaultMessage: 'Email successfully sent, check inbox for link'
    },
    emailUsedByAnotherUser: {
        id: 'app.containers.EditTeacher.emailUsedByAnotherUser',
        defaultMessage: email => `Email ${email} belongs to another user.`
    }
});



// WEBPACK FOOTER //
// ./app/containers/edit-teacher/messages.js